import { render, staticRenderFns } from "./milestone-view.vue?vue&type=template&id=3c0c5d40&scoped=true"
import script from "./milestone-view.ts?vue&type=script&lang=ts&external"
export * from "./milestone-view.ts?vue&type=script&lang=ts&external"
import style0 from "./milestone-view.scss?vue&type=style&index=0&id=3c0c5d40&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c5d40",
  null
  
)

export default component.exports